import styles from 'procedureStatuses/Show.scss'
import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Progress as ProgressBar} from 'components/Progress'
import DropDownMenu from 'components/DropDownMenu'
import {actionCreators} from 'actions'
import api from 'api'
import {Timeline} from 'features/procedures/Timeline/Timeline'
import {makeMaternityDatum} from 'procedures/maternityLeave/Form'
import {asyncError} from 'store/actions/asyncError'
import {MenuEllipsis} from 'jbc-front/components/icons'

export const TodoList = ({procedureStatus}) => {
  const procedureMaternityDatum = makeMaternityDatum(procedureStatus)
  const token = useSelector((state) => state.auth.token)
  const dispatch = useDispatch()
  const updateTodo = (todoListNo, todoNo, todoId, status) => {
    try {
      dispatch(actionCreators.procedureStatuses.updateTodo({todoListNo, todoNo, status}))
      api.createWithAuth(token).todos.update(todoId, status)
    } catch (err) {
      dispatch(asyncError(err))
    }
  }
  const handleTodoChange = (todoListNo, todoNo, todo) => {
    updateTodo(todoListNo, todoNo, todo.id, todo.status == 'todo' ? 'done' : 'todo')
  }
  const {
    started_at: startedAt,
    expected_birth_date: expectedBirthDate,
    expected_finished_at: expectedFinishedAt,
  } = procedureMaternityDatum

  const timelineItems = []
  timelineItems.push({type: 'event', date: startedAt, label: '産休開始日'})

  if (procedureStatus.procedure_start_maternity_datum) {
    timelineItems.push({
      type: 'procedure',
      title: '産休開始手続き',
      todoLists: procedureStatus.todo_lists
        .map((todoList, todoListNo) => todoList.procedure_type === 'start_maternity' && {...todoList, todoListNo})
        .filter((v) => v),
    })
  }

  const hasOnlyStart =
    !!procedureStatus.procedure_start_maternity_datum &&
    !procedureStatus.procedure_extend_maternity_datum &&
    !procedureStatus.procedure_finish_maternity_datum
  timelineItems.push({
    type: 'event',
    date: expectedBirthDate,
    label: '出産予定日',
    link: hasOnlyStart && {
      to: `/extend_maternity/detail?employee_id=${procedureStatus.employee_id}&procedure_id=${procedureStatus.id}`,
      label: '変更する',
    },
  })

  if (procedureStatus.procedure_extend_maternity_datum) {
    timelineItems.push({
      type: 'procedure',
      title: '産休延長手続き',
      todoLists: procedureStatus.todo_lists
        .map((todoList, todoListNo) => todoList.procedure_type === 'extend_maternity' && {...todoList, todoListNo})
        .filter((v) => v),
    })
  }

  if (procedureStatus.procedure_finish_maternity_datum) {
    timelineItems.push({
      type: 'procedure',
      title: '産休終了手続き',
      todoLists: procedureStatus.todo_lists
        .map((todoList, todoListNo) => todoList.procedure_type === 'finish_maternity' && {...todoList, todoListNo})
        .filter((v) => v),
    })
  }

  timelineItems.push({
    type: 'event',
    date: procedureStatus.procedure_finish_maternity_datum
      ? procedureStatus.procedure_finish_maternity_datum.finished_at
      : expectedFinishedAt,
    label: '産休終了日',
    link: !procedureStatus.procedure_finish_maternity_datum && {
      to: `/finish_maternity/detail?employee_id=${procedureStatus.employee_id}&procedure_id=${procedureStatus.id}`,
      label: '予定日前に終了する',
    },
  })

  return <Timeline items={timelineItems} onTodoChange={handleTodoChange} />
}

export const Progress = () => {
  const procedureStatus = useSelector((state) => state.procedureStatuses.current.data)
  if (!procedureStatus) {
    return null
  }
  const allTodoStatuses = procedureStatus.todo_lists.flatMap(({todos}) => todos).map(({status}) => status)
  const doneTodoStatusesCount = allTodoStatuses.filter((s) => s === 'done').length
  const progress = Math.floor((doneTodoStatusesCount / allTodoStatuses.length) * 100)

  return (
    <>
      <ProgressBar progress={progress} key="progress" className={styles.progressBar} large />
      進捗状況：{' '}
      <span className={styles.statusCount}>
        {doneTodoStatusesCount}/{allTodoStatuses.length}
      </span>
      <span className={styles.statusTag}>{doneTodoStatusesCount === allTodoStatuses.length ? '完了' : '対応中'}</span>
    </>
  )
}

const toggle = ({onClick}) => (
  <a className={styles.todoMenu} onClick={onClick}>
    <MenuEllipsis size={20} />
  </a>
)

export const Menu = ({menuItemsEmptyTodo}) => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const procedureStatus = useSelector((state) => state.procedureStatuses.current.data)
  const handleTodoChangeAll = async (status) => {
    try {
      dispatch(actionCreators.procedureStatuses.updateTodoAll({status}))
      await api.createWithAuth(token).procedureStatuses.updateTodoAll(procedureStatus.id, status)
    } catch (err) {
      dispatch(asyncError(err))
    }
  }
  const menuItems = [
    {
      onClick: () => {
        handleTodoChangeAll('done')
      },
      label: '全て完了にする',
    },
    {
      onClick: () => {
        handleTodoChangeAll('todo')
      },
      label: '全て対応中に戻す',
    },
    ...menuItemsEmptyTodo,
  ]
  return procedureStatus && <DropDownMenu toggle={toggle} menuItems={menuItems} />
}
